module.exports = __webpack_public_path__ + "img/laboratorio4_4-3_3072.f7183472.jpg";